// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3CFV4","title":"InfoRow_title__34aZs"};